// (function($) {

//   function changeGoogleStyles() {
//     console.log('Style Google Translate');
//     var $goog = $('.goog-te-menu-frame').contents().find('body');
//     if(($goog).length) {
//         var stylesHtml = '<style>'+
//             '.goog-te-menu2 {'+
//                 'max-width:100% !important;'+
//                 'overflow:scroll !important;'+
//                 'box-sizing:border-box !important;'+
//                 'height:auto !important;'+
//             '}'+
//         '</style>';
//         $goog.prepend(stylesHtml);
//     } else {
//         setTimeout(changeGoogleStyles, 50);
//     }
//   }
//   changeGoogleStyles();

// })(jQuery);
